// 通知
export default [{ // 通知管理
  path: '/notificationManager',
  name: 'notificationManager',
  component: resolve => require(['@/views/notification/notificationManager.vue'], resolve),
  meta: {
    group: "/notificationManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 新增通知
  path: '/addNotification',
  name: 'addNotification',
  component: resolve => require(['@/views/notification/addNotification.vue'], resolve),
  meta: {
    group: "/notificationManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 编辑通知
  path: '/editNotification',
  name: 'editNotification',
  component: resolve => require(['@/views/notification/addNotification.vue'], resolve),
  meta: {
    group: "/notificationManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 查看通知
  path: '/viewNotification',
  name: 'viewNotification',
  component: resolve => require(['@/views/notification/addNotification.vue'], resolve),
  meta: {
    group: "/notificationManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/notification/notification.js